import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Image from '../Image'
import './styles/ProjectCard.css';

class ProjectCard extends Component {
    render() {
        const project = this.props.project;

        const img = project.images.placeholder || project.images.gallery[0].thumb;

        return (
            <Link className={'card-project'} to={
                {
                    pathname: `/projects/${project.key}`,
                    state: {modal: false}
                }
            }>
                <Image src={img} aspectRatio={'4:3'} cover shadow/>
                <div className='card-project__body'>
                    <div className={'title'}>
                        {project.title}
                    </div>
                </div>
            </Link>
        );
    }
}

export default ProjectCard;